import { ref } from "vue";
import { createI18n } from "vue-i18n";
import loadLocale from "@/plugins/vee-validate";

import { APP_LANGUAGES } from "@/types/enum/ionicEnum";

import { messages, MessageSchema } from "@/assets/lang";

const preferredLanguage = ref<string | APP_LANGUAGES>(localStorage.getItem('localeLanguage') ?? APP_LANGUAGES.DE)

const i18n = createI18n<[MessageSchema], APP_LANGUAGES>({
    locale: preferredLanguage.value,
    fallbackLocale: APP_LANGUAGES.DE,
    messages,
    legacy: false,
    globalInjection: true
})

export default i18n

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { t } = i18n.global

// TODO: Remove ts-ignore (rewrite logit to change language)
const changeLanguage = async (language: string): Promise<void> => {
    //! New Version is not supported yet
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    i18n.global.locale.value = language;
    document.title = t('title').toString()
    document.documentElement.setAttribute('lang', language)
    localStorage.setItem('localeLanguage', language)
    await loadLocale(language)
    window.dispatchEvent(new Event('change-language'))
}

export {
    changeLanguage,
    t
}

loadLocale(preferredLanguage.value)
